import { useIsAllowed } from '../../utils/useCurrentUser';
import { Loading } from 'carbon-components-react';

export default function ComponentGuard({
  children,
  allowedRoles = [],
  showLoader = false,
}) {
  const { isAllowed, isLoadingUser } = useIsAllowed();

  return (
    <>
      {isLoadingUser ? (
        <>{showLoader ? <Loading small withOverlay={false} /> : ''}</>
      ) : allowedRoles.length === 0 || isAllowed(allowedRoles) ? (
        children
      ) : null}
    </>
  );
}
